const queryParamExists = param => new URL(window.location.href).searchParams.has(param);

export default queryParamExists;
